import { render, staticRenderFns } from "./LikeReply.vue?vue&type=template&id=e50d81a2"
import script from "./LikeReply.vue?vue&type=script&lang=js"
export * from "./LikeReply.vue?vue&type=script&lang=js"
import style0 from "./LikeReply.vue?vue&type=style&index=0&id=e50d81a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports